import React from 'react'

interface Props {
  color?: string
  size?: number
}

const Check = React.forwardRef(
  (
    { color = 'currentColor', size = 16, ...rest }: Props,
    ref: React.LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        className="text-white"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
        stroke={color}
        {...rest}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 13l4 4L19 7"
        />
      </svg>
    )
  }
)

export default Check
